const getSystemEnvironment = (breakpointsService) => {
    if (breakpointsService.isInLargeFormat) {
        return 'Desktop';
    } else if (breakpointsService.isInMediumFormat) {
        return 'Tablet';
    }

    return 'Mobile';
};

class PageAnalytics {
    constructor(analytics, $rootScope, $location, $window, $document, breakpointsService, shopperService, shopperAnalytics) {
        this.analytics = analytics;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.$window = $window;
        this.$document = $document;
        this.breakpointsService = breakpointsService;
        this.shopperService = shopperService;
        this.shopperAnalytics = shopperAnalytics;
    }

    setupPageChangeWatchers() {
        /**
         * Location Change Success event is fired once on actual page reload.
         */
        this.$rootScope.$on('$locationChangeSuccess', (e, toUrl, fromUrl) => {
            // Update Page Analytics.
            this.push(toUrl, fromUrl);
        });
    }

    push(toUrl, fromUrl) {
        const analyticsPageInfoData = {
            sysEnv: getSystemEnvironment(this.breakpointsService),
            variant: this.$window.navigator.userAgent,
            language: this.$window.navigator.language,
            toUrl,
            fromUrl: toUrl === fromUrl ? this.$document[0].referrer : fromUrl,
        };

        this.analytics.push({ data: analyticsPageInfoData, type: this.analytics.mapperTypes.seo.pageInfo });
    }
}

module.exports = PageAnalytics;



// WEBPACK FOOTER //
// ./src/configuration/analytics/page-analytics.js